import { fcaFastApi, fcaGateWay, fcaReportGateway } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";
import { isEnabled } from "../../services/featureFlags";

// Auth/session/password endpoints migrated to FastAPI (FCA-6761). Gated by the
// `migrate_auth_session` FME flag: fail-safe OFF => keep using the Ruby gateway.
// Endpoint paths are identical on both backends, so only the client swaps.
const authClient = () => (isEnabled("migrate_auth_session") ? fcaFastApi : fcaGateWay);

// users/detail belongs to the users slice (FCA-6861), not the auth slice: it
// is gated by `migrate_users_permissions` (fail-safe OFF => Ruby gateway).
export const getUserDetails = () =>
    (isEnabled("migrate_users_permissions") ? fcaFastApi : fcaGateWay).get(serviceEndpoints.userEndPoints.getUserDetails);
export const loginUserPython = param => fcaFastApi.post(serviceEndpoints.userEndPoints.loginUserPython, param);
export const logoutUser = param => authClient().delete(serviceEndpoints.userEndPoints.logoutUser, param);
export const revokeToken = param => fcaFastApi.post(serviceEndpoints.userEndPoints.revokeToken, param);

export const forgotPassword = param => authClient().post(serviceEndpoints.userEndPoints.forgotPassword, param);
export const resetPassword = param => authClient().post(serviceEndpoints.userEndPoints.resetPassword, param);
export const CognitoLoginOTP = param => fcaFastApi.post(serviceEndpoints.userEndPoints.CognitoLoginOTP, param);

export const validateToken = token =>
    authClient().get(`${serviceEndpoints.userEndPoints.verifyToken}`, { params: { token } });

export const ssoLogin = param => fcaFastApi.post(serviceEndpoints.userEndPoints.ssoCallback, param);

export const resolveTenant = param => fcaFastApi.post(serviceEndpoints.userEndPoints.resolveTenant, param);

export const resetPasswordProfile = (id, param) =>
    authClient().patch(`${serviceEndpoints.userEndPoints.resetPasswordProfile}/${id}/update_password`, param);
